(() => {
  const form = document.getElementById(
    `back-in-stock-subscription-${document.currentScript.getAttribute(
      "data-section"
    )}`
  );

  if (!form) return;

  const klaviyoRegions = {
    US: "na",
    CA: "ca",
    FR: "eu",
    NO: "no",
    DK: "dk",
    DE: "de",
  };

  const successMessage = form.querySelector("[data-alert-success]");
  const errMessage = form.querySelector("[data-alert-err]");
  const submitButton = form.querySelector('button[type="submit"]');

  const dialog = document.getElementById("back-in-stock-modal");
  const openKlaviyoModal = document.getElementById("open-klaviyo-modal");
  const closeKlaviyoModal = document.getElementById("close-klaviyo-modal");

  openKlaviyoModal.addEventListener("click", () => dialog.showModal());
  closeKlaviyoModal.addEventListener("click", () => dialog.close());
  dialog.addEventListener("click", (e) => {
    const dialogDimensions = dialog.getBoundingClientRect();
    if (
      e.clientX < dialogDimensions.left ||
      e.clientX > dialogDimensions.right ||
      e.clientY < dialogDimensions.top ||
      e.clientY > dialogDimensions.bottom
    ) {
      dialog.close();
    }
  });

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    const { list_id } = window.klaviyo_config;
    const formData = new FormData(form);

    const requestUrl = `https://api-proxy.soundboks.com/prod/klaviyo/backInStock`;
    const headers = new Headers({ "Content-Type": "application/json" });
    const body = JSON.stringify({
      region: klaviyoRegions[formData.get("country")],
      data: { profiles: { email: formData.get("email") } },
      variantId: formData.get("variantId"),
      listId: list_id,
    });

    await fetch(requestUrl, { method: "POST", headers, body })
      .then((res) => {
        if (res.status === 200) {
          window.dataLayer = window.dataLayer || [];
          dataLayer.push({
            event: "generate_lead",
            subscription_source: "back-in-stock-form",
            user_data: {
              email: formData.get("email"),
            },
          });
          submitButton.setAttribute("aria-busy", "false");
          submitButton.style.display = "none";
          successMessage.hidden = false;
          return;
        }
        return res.json();
      })
      .catch((err) => {
        console.error("error:" + err);
        submitButton.setAttribute("aria-busy", "false");
        errMessage.hidden = false;
        return;
      });
  });
})();
